import {ApiClient} from "../api-client";
import {AssignmentIdentity} from "@k2/common/entities-state/types";
import {map} from "rxjs/operators";

export class DomesticHomePurchaseEndpoint {
  constructor(private api: ApiClient) {
  }

  fetchServiceOverview = ({clientId, assignmentId}: AssignmentIdentity) => {
    return this.api
      .get(`/staff/clients/${clientId}/assignments/${assignmentId}/domestic-home-purchase/service-overview`);
  };

  fetchPurchaseInformation = ({clientId, assignmentId}: AssignmentIdentity) => {
    return this.api
      .get(`/staff/clients/${clientId}/assignments/${assignmentId}/domestic-home-purchase/purchase-information`)
      .pipe(map(payload => payload.form));
  }

  savePurchaseInformation = ({clientId, assignmentId}: AssignmentIdentity, data: any) => {
    return this.api.post(`/staff/clients/${clientId}/assignments/${assignmentId}/domestic-home-purchase/purchase-information`, data);
  }

  fetchSearchCriteria = ({clientId, assignmentId}: AssignmentIdentity) => {
    return this.api
      .get(`/staff/clients/${clientId}/assignments/${assignmentId}/domestic-home-purchase/search-criteria`)
      .pipe(map(payload => payload.form));
  }

  saveSearchCriteria = ({clientId, assignmentId}: AssignmentIdentity, data: any) => {
    return this.api.post(`/staff/clients/${clientId}/assignments/${assignmentId}/domestic-home-purchase/search-criteria`, data);
  }

  fetchReferralTracking = ({clientId, assignmentId}: AssignmentIdentity) => {
    return this.api
      .get(`/staff/clients/${clientId}/assignments/${assignmentId}/domestic-home-purchase/referral-tracking`)
      .pipe(map(payload => payload.form));
  }

  saveReferralTracking = ({clientId, assignmentId}: AssignmentIdentity, data: any) => {
    return this.api.post(`/staff/clients/${clientId}/assignments/${assignmentId}/domestic-home-purchase/referral-tracking`, data)
    .pipe(map(payload => payload.id));
  }
}
